import React from 'react'
import petvacc from '../Images/petvacc.jpg'
import beauban from '../Images/beautyban.jpg'
import '../Cardpage.css'
function PetVacc() {
  return (
    <>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Skin Care Products</h3>
      <img src={beauban} className='w-100 imgbanner'  alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      This section contain all Skin and Body Care products. We have the solution for many skin problems.
    </p>
    <div className='petvaccdiv'>
      <div>
      <h5 className='cardpagehead5'>
      Products lists:
    </h5>
    <ul>
      <li>Vitamin creams</li>
      <li>Body Lotions</li>
      <li>Face Wash</li>
      <li>Mousturizing Creams</li>
      <li>Serums</li>
      <li>Sun Screens</li>
      <li>Hair protectors</li>
      <li>Pure Exctract Oils</li>
    </ul>
      </div>
    </div>
    <p className='ms-2 pagebott'>Visit our store to explore wide range of beauty products... </p>
    </>
  )
}

export default PetVacc